(function () {
  const initSlider = (section) => {
    const box = section.querySelector(".multicolumn");
    const slider = section.querySelector(".swiper--multicolumn");

    if (!slider) return;

    const slides = slider.querySelectorAll(".multicolumn-card");

    slides.forEach((slide) => {
      slide.classList.add("swiper-slide");
    });

    const spaceBetween = box.getAttribute("data-space-between")
      ? Number(box.getAttribute("data-space-between")) * 10
      : 24;

    const spaceBetweenMobile = slider.classList.contains(
      "swiper--multicolumn--visible-overflow"
    )
      ? 16
      : 20;

    const nextBtn = slider.querySelector(".multicolumn-button--next");
    const prevBtn = slider.querySelector(".multicolumn-button--prev");
    const scrollbar = box.querySelector(".swiper-scrollbar");

    new Swiper(slider, {
      loop: false,
      slidesPerView: "auto",
      spaceBetween: spaceBetweenMobile,
      speed: 800,
      mousewheel: {
        forceToAxis: true,
      },
      watchSlidesProgress: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "multicolumn-button--disabled",
      },
      scrollbar: {
        el: scrollbar,
        grabCursor: true,
        draggable: true,
        hide: false,
      },
      breakpoints: {
        576: {
          spaceBetween: spaceBetween,
        },
      },
    });
  };

  const destroySlider = (section) => {
    const slider = section.querySelector(".swiper--multicolumn");
    const slides = section.querySelectorAll(".multicolumn-card");

    if (slider?.swiper) slider.swiper.destroy();

    slides.forEach((slide) => {
      slide.removeAttribute("style");
      slide.classList.remove("swiper-slide");
    });
  };

  const initMulticolumn = (section) => {
    if (!section || !section?.classList.contains("multicolumn-section")) return;

    const box = section.querySelector(".multicolumn");

    if (!box) return;

    const hasMobileSlider =
      box.getAttribute("data-enable-mobile-slider") === "true";
    const hasDesktopSlider =
      box.getAttribute("data-enable-desktop-slider") === "true";

    const sectionResizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.contentRect.width < 576 && hasMobileSlider) {
          initSlider(section);
        } else if (entry.contentRect.width >= 576 && hasDesktopSlider) {
          initSlider(section);
        } else {
          destroySlider(section);
        }
      });
    });

    sectionResizeObserver.observe(section);
  };

  const initCursor = (section) => {
    if (!section || !section?.classList.contains("multicolumn-section")) {
      return;
    }

    const box = section.querySelector(".multicolumn");
    const cursorEl = section.querySelector(".multicolumn__cursor");
    const sliderEl = box.querySelector(".swiper--multicolumn");

    if (!box || !cursorEl) return;

    const slidesCounts = Number(box.getAttribute("data-slides-count"));
    if (slidesCounts <= 1) return;

    const handleMouseMove = (event) => {
      cursorEl.classList.add("active");
      cursorEl.classList.remove("disabled");

      const sectionRect = sliderEl.getBoundingClientRect();
      const sectionWidth = sectionRect.width;
      const sectionCenterX = sectionRect.left + sectionWidth / 2;

      if (!sliderEl?.swiper) return;
      const slider = sliderEl.swiper;

      const x = event.clientX - sectionRect.left - 18;
      const y = event.clientY - sectionRect.top - 18;

      if (event.clientX < sectionCenterX) {
        cursorEl.classList.add("prev");
        cursorEl.classList.remove("next");

        if (slider.isBeginning) {
          cursorEl.classList.add("disabled");
        }
      } else {
        cursorEl.classList.remove("prev");
        cursorEl.classList.add("next");

        if (slider.isEnd) {
          cursorEl.classList.add("disabled");
        }
      }

      cursorEl.style.left = `${x}px`;
      cursorEl.style.top = `${y}px`;
    };

    const handleMouseLeave = () => {
      cursorEl.classList.remove("active");
      cursorEl.classList.remove("disabled");
    };

    const handleClick = (event) => {
      if (event.target.classList.contains("swiper-scrollbar")) return;
      const sectionRect = box.getBoundingClientRect();
      const sectionWidth = sectionRect.width;
      const sectionCenterX = sectionRect.left + sectionWidth / 2;

      const sliderEl = box.querySelector(".swiper--multicolumn");
      if (!sliderEl?.swiper) return;
      const slider = sliderEl.swiper;

      const hasNextSlide = !slider.isEnd;
      const hasPrevSlide = !slider.isBeginning;

      if (event.clientX < sectionCenterX && hasPrevSlide) {
        slider.slidePrev();
      } else if (event.clientX >= sectionCenterX && hasNextSlide) {
        slider.slideNext();
      }
    };

    let isCursorInit = false;

    if (
      window.innerWidth >= 576 &&
      window.matchMedia("(pointer:fine)").matches
    ) {
      sliderEl.addEventListener("mousemove", handleMouseMove);
      sliderEl.addEventListener("mouseleave", handleMouseLeave);
      sliderEl.addEventListener("click", handleClick);

      isCursorInit = true;
    }

    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.contentRect.width >= 576) {
          if (!isCursorInit) {
            sliderEl.addEventListener("mousemove", handleMouseMove);
            sliderEl.addEventListener("mouseleave", handleMouseLeave);
            sliderEl.addEventListener("click", handleClick);

            isCursorInit = true;
          }
        } else {
          if (isCursorInit) {
            sliderEl.removeEventListener("mousemove", handleMouseMove);
            sliderEl.removeEventListener("mouseleave", handleMouseLeave);
            sliderEl.removeEventListener("click", handleClick);

            isCursorInit = false;
          }
        }
      });
    });

    resizeObserver.observe(section);
  };

  initMulticolumn(document.currentScript.parentElement);
  initCursor(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initMulticolumn(event.target);
    initCursor(event.target);
  });
})();
